import { render, staticRenderFns } from "./OrganizationViewOrganizationTimetableCard.vue?vue&type=template&id=55c6a367"
import script from "./OrganizationViewOrganizationTimetableCard.vue?vue&type=script&lang=js"
export * from "./OrganizationViewOrganizationTimetableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports